import { Option } from 'funfix-core';
import { Map, Record } from 'immutable';
import { STRIDE_CONTEXT_TYPE } from '../types/ContextType';
export const makeAddonDiscoveryConfig = Record({
  featuredContentOverride: Option.empty(),
  productKey: '',
  hiddenFilters: Map()
});
export const makeTokenConfig = Record({
  exampleBody: {},
  exampleEndpoint: () => '',
  explanation: '',
  endpointVerb: ''
});
export const makeHostConfig = Record({
  addonDiscovery: makeAddonDiscoveryConfig(),
  analytics: {
    productName: '',
    getSubproduct: _ => {
      /* no subproduct by default */
    }
  },
  contextType: STRIDE_CONTEXT_TYPE,
  errors: Map(),
  featureFlags: {
    productName: ''
  },
  globalContext: Option.empty(),
  installedApps: {
    globallyInstalledApps: {
      sectionHeading: '',
      sectionDescription: ''
    },
    locallyInstalledApps: {
      sectionHeading: ''
    }
  },
  installationLocation: '',
  isCloseable: false,
  name: '',
  removeFromSite: {
    actionSummary: () => '',
    confirmation: () => '',
    // eslint-disable-line react/display-name
    successNotification: () => ''
  },
  token: makeTokenConfig(),
  supportsManage: false,
  welcomeHeader: '',
  welcomeSubheader: ''
});